// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__oYer7","title":"Images90_title__3dKx3","images":"Images90_images__mjnbP"};